import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMobileOKCallback } from '../hooks/useMobileOK';

/**
 * Mobile-OK 본인확인 콜백 페이지
 *
 * 라우터에 등록 필요:
 * <Route path="/auth/mobileok/callback" element={<MobileOKCallback />} />
 *
 * 결과 처리 후 부모 창으로 메시지 전송 후 자동 닫힘
 */
function MobileOKCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { result, isLoading, error } = useMobileOKCallback({
    onSuccess: (result) => {
      // 부모 창으로 성공 메시지 전송
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'MOBILEOK_SUCCESS',
            data: result,
          },
          window.location.origin,
        );
        window.close();
      } else {
        // 팝업이 아닌 경우 (리다이렉트 방식)
        // 세션 스토리지에 결과 저장 후 이전 페이지로
        sessionStorage.setItem('mobileok_result', JSON.stringify(result));
        navigate(-1);
      }
    },
    onError: (error) => {
      // 부모 창으로 에러 메시지 전송
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'MOBILEOK_ERROR',
            error: error.message,
          },
          window.location.origin,
        );
        window.close();
      } else {
        // 팝업이 아닌 경우
        sessionStorage.setItem(
          'mobileok_error',
          JSON.stringify({ message: error.message }),
        );
        navigate(-1);
      }
    },
  });

  // 팝업 창에서 부모 창의 메시지 리스너 등록 안내
  useEffect(() => {
    // 부모 창이 없으면 안내 표시
    if (!window.opener) {
      console.log(
        '[MobileOKCallback] No opener window. Using session storage for result.',
      );
    }
  }, []);

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <div
          style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #333',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
        <p style={{ color: '#666', fontSize: '14px' }}>
          본인확인 결과를 처리하고 있습니다...
        </p>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: '16px',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        <p style={{ color: '#e74c3c', fontSize: '16px', fontWeight: 'bold' }}>
          본인확인에 실패했습니다
        </p>
        <p style={{ color: '#666', fontSize: '14px' }}>{error.message}</p>
        <button
          onClick={() => window.close()}
          style={{
            padding: '12px 24px',
            backgroundColor: '#333',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          닫기
        </button>
      </div>
    );
  }

  if (result) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <p style={{ color: '#27ae60', fontSize: '16px', fontWeight: 'bold' }}>
          본인확인이 완료되었습니다
        </p>
        <p style={{ color: '#666', fontSize: '14px' }}>
          잠시 후 자동으로 닫힙니다...
        </p>
      </div>
    );
  }

  return null;
}

export default MobileOKCallback;